import type { RoasterListItem } from "@bcc/components/admin/roaster-list.types";
import type { DataTableRow } from "@client-shared";

/**
 * Sample roaster data for the admin impersonation list
 */
export const sampleRoasters: DataTableRow<RoasterListItem>[] = [
  {
    id: "1",
    roasterName: "Premium Coffee Roasters",
    roasterEmail: "contact@premiumcoffee.com",
    platform: "shopify",
    status: "active",
    lastActive: "2026-01-28T10:30:00Z",
    accountType: "beanz",
  },
  {
    id: "2",
    roasterName: "Artisan Bean Company",
    roasterEmail: "hello@artisanbean.com",
    platform: "woocommerce",
    status: "active",
    lastActive: "2026-01-27T15:45:00Z",
    accountType: "shipstation",
  },
  {
    id: "3",
    roasterName: "Mountain View Coffee",
    roasterEmail: "info@mountainviewcoffee.com",
    platform: "shopify",
    status: "active",
    lastActive: "2026-01-28T09:15:00Z",
    accountType: "beanz",
  },
  {
    id: "4",
    roasterName: "Urban Roast Collective",
    roasterEmail: "team@urbanroast.com",
    platform: "woocommerce",
    status: "inactive",
    lastActive: "2026-01-20T14:20:00Z",
    accountType: "beanz",
  },
  {
    id: "5",
    roasterName: "Coastal Coffee Co.",
    roasterEmail: "support@coastalcoffee.com",
    platform: "woocommerce",
    status: "active",
    lastActive: "2026-01-28T11:00:00Z",
    accountType: "beanz",
  },
  {
    id: "6",
    roasterName: "Highland Roasters",
    roasterEmail: "contact@highlandroasters.com",
    platform: "shopify",
    status: "pending",
    lastActive: "2026-01-26T16:30:00Z",
    accountType: "shipstation",
  },
  {
    id: "7",
    roasterName: "Sunset Brew Company",
    roasterEmail: "info@sunsetbrew.com",
    platform: "woocommerce",
    status: "active",
    lastActive: "2026-01-28T08:45:00Z",
    accountType: "beanz",
  },
  {
    id: "8",
    roasterName: "Metro Coffee Lab",
    roasterEmail: "hello@metrocoffeelab.com",
    platform: "shopify",
    status: "active",
    lastActive: "2026-01-27T13:20:00Z",
    accountType: "beanz",
  },
  {
    id: "9",
    roasterName: "Valley Roast House",
    roasterEmail: "team@valleyroasthouse.com",
    platform: "woocommerce",
    status: "active",
    lastActive: "2026-01-28T07:30:00Z",
    accountType: "shipstation",
  },
  {
    id: "10",
    roasterName: "Lakeside Coffee Works",
    roasterEmail: "contact@lakesidecoffee.com",
    platform: "woocommerce",
    status: "inactive",
    lastActive: "2026-01-15T10:00:00Z",
    accountType: "beanz",
  },
  {
    id: "11",
    roasterName: "Downtown Bean Bar",
    roasterEmail: "info@downtownbeanbar.com",
    platform: "shopify",
    status: "active",
    lastActive: "2026-01-28T12:15:00Z",
    accountType: "beanz",
  },
  {
    id: "12",
    roasterName: "Forest Peak Coffee",
    roasterEmail: "hello@forestpeakcoffee.com",
    platform: "woocommerce",
    status: "active",
    lastActive: "2026-01-27T17:00:00Z",
    accountType: "shipstation",
  },
];
